export default {
  ButtonGroupAdapter__BUTTON_GROUP_ARIA_NEXT: "Next",
  ButtonGroupAdapter__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
};
